// extracted by mini-css-extract-plugin
module.exports = {"comp":"FreeGridSection_comp__dIQQG"};